import React from 'react';
import { Zap, ShieldCheck } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import apiClient from '../../lib/apiClient';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import ProgressDashboard from './ProgressDashboard';
import BacklogAnalysisPanel from './BacklogAnalysisPanel';
import CampaignBuilder from './CampaignBuilder';
import CampaignHistory from './CampaignHistory';
import './BacklogBuster.css';

/**
 * BacklogBuster — admin/cisco_user surface for clearing the unclassified
 * procurement backlog with targeted campaigns. Wraps the backend
 * /api/backlog-buster/* endpoints (analyze, progress, campaigns).
 */
function BacklogBuster() {
  useDocumentTitle('Backlog Buster');

  // Departments power the campaign-builder dropdown. We refetch infrequently
  // — this is the same shape MainApp uses for its dept selector.
  const deptsQuery = useQuery({
    queryKey: ['departments', 'all'],
    queryFn: () => apiClient.get('/api/departments'),
    staleTime: 10 * 60_000,
  });

  return (
    <div className="bb-page">
      <header className="bb-page__head">
        <div className="bb-page__title">
          <Zap size={22} />
          <div>
            <h1>Backlog Buster</h1>
            <p className="bb-page__sub">
              Surface why items remain unclassified, then run targeted
              campaigns (Rules → Gemma → Claude) to clear the long tail.
              Every campaign writes through the same classification pipeline,
              so promoted results enter <code>component_mapping_rules</code>{' '}
              and improve the deterministic layer permanently.
            </p>
          </div>
        </div>
        <div className="bb-page__principles">
          <span className="bb-pill bb-pill--muted">
            <ShieldCheck size={11} /> Cheap tier first · LLM only for the long tail
          </span>
        </div>
      </header>

      <ProgressDashboard />

      <BacklogAnalysisPanel />

      <CampaignBuilder departments={deptsQuery.data || []} />

      <CampaignHistory />
    </div>
  );
}

export default BacklogBuster;
